"use strict";
/**
 * getTodaysDateInNumbers function getting todays date as number
 *
 *  @returns {string} - The formatted string(YYYYMMDD), or empty string based on conditions.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTodaysDateInNumbers = void 0;
const getTodaysDateInNumbers = () => {
    const today = new Date();
    const year = today.getFullYear().toString();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    return year + month + day;
};
exports.getTodaysDateInNumbers = getTodaysDateInNumbers;
